import { ReverseProductUploadContext } from 'app/reverse-auction-upload-wizard/reverse-auction-upload-wizard.component';
import { FileService } from 'app/_services/file.service';
import { ReverseAuctionResource } from 'app/_resources/reverse-auction.resource';
import { UtilService } from 'app/_services/util.service';
import { ReverseAuctionUploadWizardService } from 'app/_services/reverse-auction-upload-wizard.service';
import * as angular from 'angular';
import { mgoAngularWizard } from '../custom';

class ReverseUploadWizardSummary implements ng.IController {
    public wizardCtrl: mgoAngularWizard.Wizard<ReverseProductUploadContext>;
    public ui = {};
    public errorDetailsVisible = false;

    constructor(
        private fileService: FileService,
        private reverseAuctionResource: ReverseAuctionResource,
        private utilService: UtilService,
        private reverseAuctionUploadWizardService: ReverseAuctionUploadWizardService
    ) {}

    $onInit(): void {
        if (this.isNewProductSet(this.wizardCtrl.context.data.wizardGuid)) {
            this.wizardCtrl.context.transferData.push(
                this.wizardCtrl.context.data
            );
        }
    }

    public isNewProductSet(guid) {
        var result = this.wizardCtrl.context.transferData.filter(
            (item) => item.wizardGuid == guid
        );
        return result.length === 0;
    }

    public editProduct(wizardGuid) {
        this.wizardCtrl.context.data =
            this.wizardCtrl.context.transferData.find(
                (td) => td.wizardGuid === wizardGuid
            );
        this.wizardCtrl.goTo(1);
    }

    public copyAddReverseAuction(mode) {
        if (mode === 'add') {
            this.wizardCtrl.context.data =
                this.wizardCtrl.context.createWizardRunBaseData();
            this.wizardCtrl.goTo(0);
        } else if (mode === 'copy') {
            this.wizardCtrl.context.data = this.removeOfferIdsFromProducts(
                angular.copy(this.wizardCtrl.context.data)
            );
            this.wizardCtrl.context.data.wizardGuid =
                this.utilService.generateGuid();
            this.wizardCtrl.goTo(1);
        }
    }

    public removeOfferIdsFromProducts(data) {
        data.offerId = '';
        return data;
    }

    public downloadXml() {
        var payload = this.reverseAuctionUploadWizardService.getMappedData({
            transferData: this.wizardCtrl.context.transferData,
            competition: this.wizardCtrl.context.competition
        });
        this.reverseAuctionResource.generateXml(payload, (res) => {
            this.fileService.triggerFileDownload(
                res.responseXml,
                'upload.xml',
                'text/xml'
            );
        });
    }

    public downloadResponse() {
        if (this.wizardCtrl.context.data.uploadSuccessful) {
            this.fileService.triggerFileDownload(
                this.wizardCtrl.context.data.successDetails,
                'response.xml',
                'text/xml'
            );
        }
    }

    public deleteProduct(offerId) {
        let delIndex;
        angular.forEach(
            this.wizardCtrl.context.transferData,
            (product, index) => {
                if (product.offerId === offerId) {
                    delIndex = index;
                }
            }
        );
        this.wizardCtrl.context.transferData.splice(delIndex, 1);

        if (this.wizardCtrl.context.transferData.length == 0) {
            this.wizardCtrl.context.data =
                this.wizardCtrl.context.createWizardRunBaseData();
            this.wizardCtrl.goTo(0);
        }
    }

    public submit(isValid): boolean {
        if (!isValid) {
            return false;
        }
        this.wizardCtrl.next();
        return true;
    }

    public toggleErrorDetails() {
        this.errorDetailsVisible = !this.errorDetailsVisible;
    }
}

angular.module('app').component('pkpReverseAuctionUploadWizardSummary', {
    controller: ReverseUploadWizardSummary,
    template:
        require('app/reverse-auction-upload-wizard/reverse-auction-upload-wizard-summary.component.html'),
    require: {
        wizardCtrl: '^^wizard'
    },
    bindings: {}
});
